import { useCallback, useState } from 'react'
import { AxiosResponse } from 'axios'
import { AxiosError } from 'axios'
import { api, ApiRoutes } from '../services/ApiService'

type Pagination = {
    total: number
    perPage: number
    currentPage: number
    lastPage: number
}

export const useFetchData = <DataType>(url: ApiRoutes) => {
    const [data, setData] = useState<DataType[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const [pagination, setPagination] = useState<Pagination | null>(null)

    type ResponseType = {
        data: DataType[] | null
        pagination: Pagination | null
    }

    const handleFetchData = useCallback(
        (params?: Record<string, string>) => {
            setIsLoading(true)
            setError(null)

            api.get(url, undefined, params)
                .then((response: AxiosResponse<ResponseType>) => {
                    if (response.data?.data) {
                        setData(response.data.data)
                        setPagination(response.data.pagination)
                    }
                })
                .catch((error: AxiosError) => {
                    setError(
                        '[' + error.response?.status + ']: ' + error.message
                    )
                })
                .finally(() => {
                    setIsLoading(false)
                })
        },
        [url]
    )

    return {
        data,
        isLoading,
        error,
        fetch: handleFetchData,
        pagination,
    }
}
